<!-- Google tag (gtag.js) -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-GGG06JN29G"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-GGG06JN29G');
</script>

<!-- Hero Start -->
<section class="bg-home bg-light d-flex align-items-center">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="text-center">
                    <div class="icon d-flex align-items-center justify-content-center bg-soft-primary rounded-circle mx-auto"
                        style="height: 90px; width:90px;">
                        <i class="uil uil-thumbs-up align-middle h1 mb-0"></i>
                    </div>
                    <h1 class="my-4 fw-bold">Ευχαριστούμε για την επικοινωνία</h1>
                    <p class="text-muted para-desc mx-auto">Λάβαμε το μήνυμα σας και σύντομα κάποιο μέλος της ομάδας του Orderify θα επικοινωνήσει μαζί σας.</p>
                    <a routerLink="/index" class="btn btn-soft-primary mt-3">Πίσω στην Αρχική</a>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>
<!--end section-->
<!-- Hero End -->